import { APP_CONFIG } from "config/appConfig";

export const DEFAULT_REPORT_RATE = 5; // Seconds

export enum GatewayType {
    PCS = "PCS",
    PSU = "PSU",
    POE = "POE",
    LoRaWAN = "LoRaWAN",
}

export const GATEWAY_SELECTION_TYPES = {
    IOTPORTAL: "IoTPortal Gateway",
    LORAWAN: "LoRaWAN Node",
} as const;

export const GATEWAY_ROUTES = {
    IOTPORTAL_ADD: "/gateways-add",
    LORAWAN_ADD: "/lorawan-add",
    GATEWAYS_ALL: "/gateways-all",
} as const;

export enum SensorType {
    EnergyConsumption,
    WaterConsumption,
}

// Actuator activation states
export const ACTIVATE = "activated";
export const DEACTIVATE = "deactivated";

export enum DeviceStatus {
    Online,
    Offline,
    NotFound,
}

export const DEFAULT_GATEWAY_NAME = "Unknown Gateway";

export const NetworkOBJ = "PSL_NETWORK";
const isOnPrem = APP_CONFIG.APP_IS_ONPREM;
export const GatewayTexts = isOnPrem ? "Gateways/Networks" : "Gateways";
export const GatewayText_s = isOnPrem ? "Gateway(s)/Network(s)" : "Gateway(s)";